import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Paper, Container } from '@mui/material';

const Login = ({ setIsAuthenticated }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = () => {
    // Replace with your actual admin credentials
    if (username === 'admin' && password === 'admin123') {
      setIsAuthenticated(true);
      navigate('/portal');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh', // Full viewport height
        background: 'linear-gradient(135deg, #ff9a9e, #fad0c4)', // Pinkish gradient background
      }}
    >
      <Paper
        elevation={6} // Adds shadow for a floating effect
        sx={{
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: '400px', // Limit the width for better aesthetics
          borderRadius: '12px', // Rounded corners
          background: 'rgba(255, 255, 255, 0.9)', // Slightly transparent white background
          backdropFilter: 'blur(10px)', // Blur effect for a frosted glass look
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
          FemiZero Admin
        </Typography>
        <TextField
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={{ mb: 2, width: '100%' }}
          variant="outlined"
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mb: 3, width: '100%' }}
          variant="outlined"
        />
        <Button
          variant="contained"
          onClick={handleLogin}
          sx={{
            width: '100%',
            padding: '10px',
            fontSize: '16px',
            fontWeight: 'bold',
            background: '#fc0377', // Pinkish gradient button
          }}
        >
          Login
        </Button>
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default Login;